export class PharmGroupModel{
  serial = '0' ;
  pharmacyGroupName ='' ;
  compCode ='1' ;
  userID ='sa' ;
  modifaiedDate = '2021-01-01';
}
